import $ from 'jquery';
import throttle from 'lodash.throttle';


// from https://osvaldas.info/auto-hide-sticky-header with modifications
$(function () {
    var elSelector = '.navHeader, .breadcrumb-nav',
        elClassHidden = 'header--hidden',
        elClassNarrow = 'header--narrow',
        elNavOffset = 150,
        elNarrowOffset = 50,
        throttleTimeout = 500,
        $element = $(elSelector);

    if (!$element.length) return true;

    var $window = $(window),
        wHeight = 0,
        wScrollCurrent = 0,
        wScrollBefore = 0,
        wScrollDiff = 0,
        $document = $(document),
        dHeight = 0;

    $window.on('scroll', throttle(function () {
        dHeight = $document.height();
        wHeight = $window.height();
        wScrollCurrent = $window.scrollTop();
        wScrollDiff = wScrollBefore - wScrollCurrent;

        $element.toggleClass(elClassNarrow, wScrollCurrent > elNarrowOffset); // toggles "narrow" classname

        if (wScrollCurrent <= 0) // scrolled to the very top; element sticks to the top
            $element.removeClass(elClassHidden);

        else if (wScrollDiff > 0 && $element.hasClass(elClassHidden)) // scrolled up; element slides in
            $element.removeClass(elClassHidden);

        else if (wScrollDiff < 0) // scrolled down
        {
            if (wScrollCurrent + wHeight >= dHeight && $element.hasClass(elClassHidden)) // scrolled to the very bottom; element slides in
                $element.removeClass(elClassHidden);

            else if (wScrollCurrent >= elNavOffset && $(window).width() < 1068) // scrolled down; element slides out
                $element.addClass(elClassHidden);
        }

        wScrollBefore = wScrollCurrent;
    }, throttleTimeout));
});
